/* OS EDD REV - Top Shop (scoped, no globals) */
(() => {
  const SELECTOR_ROOT = '[data-os-edd-rev-top-shop]';
  const SELECTOR_CTA = '[data-oseddrev-cta]';
  const SELECTOR_STICKY = '[data-oseddrev-sticky]';
  const SELECTOR_PRE_STICKY = '[data-oseddrev-pre-sticky]';
  const SELECTOR_STICKY_CTA = '[data-oseddrev-sticky-cta]';
  const SELECTOR_PRE_STICKY_CTA = '[data-oseddrev-pre-sticky-cta]';
  const SELECTOR_REVEAL_BTN = '[data-oseddrev-reveal-btn]';

  function parseDiscountCodes(raw) {
    const text = (raw || '').trim();
    if (!text) return [];
    // Accept comma or newline separated
    return text
      .split(/[\n,]+/g)
      .map((s) => s.trim())
      .filter(Boolean);
  }

  async function postJSON(url, bodyObj) {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(bodyObj),
      credentials: 'same-origin',
    });

    const contentType = res.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const data = isJson ? await res.json() : await res.text();

    if (!res.ok) {
      const msg =
        (data && (data.description || data.message)) ||
        (typeof data === 'string' ? data : 'Request failed');
      throw new Error(msg);
    }

    return data;
  }

  async function addItemsBatch(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: items || [] }),
      credentials: 'same-origin',
      cache: 'no-store',
    });

    const contentType = res.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const data = isJson ? await res.json() : await res.text();

    if (!res.ok) {
      const msg =
        (data && (data.description || data.message)) ||
        (typeof data === 'string' ? data : 'Request failed');
      throw new Error(msg);
    }

    return data;
  }

  async function addSingleItem(item) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(item || {}),
      credentials: 'same-origin',
      cache: 'no-store',
    });

    const contentType = res.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const data = isJson ? await res.json() : await res.text();

    if (!res.ok) {
      const msg =
        (data && (data.description || data.message)) ||
        (typeof data === 'string' ? data : 'Request failed');
      throw new Error(msg);
    }

    return data;
  }

  function wait(ms) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, ms);
    });
  }

  function setStatus(root, msg) {
    const el = root.querySelector('[data-oseddrev-status]');
    if (!el) return;
    el.textContent = msg || '';
  }

  function getScrollOffsetPx() {
    // If your theme header is visible/sticky, account for it.
    // If header is hidden (like your CSS), this will end up 0.
    try {
      const header = document.querySelector('.header-wrapper');
      if (!header) return 0;

      const style = window.getComputedStyle(header);
      if (style.display === 'none' || style.visibility === 'hidden') return 0;

      // Only offset if it’s fixed/sticky (common for Shopify headers)
      const pos = (style.position || '').toLowerCase();
      if (pos !== 'fixed' && pos !== 'sticky') return 0;

      const h = Math.round(header.getBoundingClientRect().height || 0);
      return Math.max(0, h);
    } catch (e) {
      return 0;
    }
  }

  function smoothScrollToTarget(targetEl) {
    if (!targetEl) return;

    const offset = getScrollOffsetPx();
    const rect = targetEl.getBoundingClientRect();
    const y = Math.round(window.pageYOffset + rect.top - offset - 12);

    window.scrollTo({
      top: Math.max(0, y),
      behavior: 'smooth',
    });
  }

  function bindInfoDropdowns(root) {
    const items = root.querySelectorAll('.oseddrev-topshop__infoItem');
    if (!items || !items.length) return;

    items.forEach((item) => {
      const btn = item.querySelector('[data-oseddrev-info-btn]');
      const panel = item.querySelector('[data-oseddrev-info-panel]');
      if (!btn || !panel) return;

      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        // Close all siblings (accordion behavior)
        items.forEach((sib) => {
          if (sib === item) return;
          sib.classList.remove('is-open');
          const sibBtn = sib.querySelector('[data-oseddrev-info-btn]');
          const sibPanel = sib.querySelector('[data-oseddrev-info-panel]');
          if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
          if (sibPanel) sibPanel.hidden = true;
        });

        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function bindRteScrollLinks(root) {
    const rteContainers = root.querySelectorAll(
      '.oseddrev-topshop__awardBody.rte, .oseddrev-topshop__offerBody.rte, .oseddrev-topshop__awardBodyImgRight.rte'
    );
    if (!rteContainers || !rteContainers.length) return;

    rteContainers.forEach((wrap) => {
      wrap.addEventListener('click', (e) => {
        const a = e.target && e.target.closest ? e.target.closest('a') : null;
        if (!a) return;

        const href = (a.getAttribute('href') || '').trim();
        if (!href || href === '#') return;

        if (href.charAt(0) !== '#') return;

        const id = href.slice(1);
        if (!id) return;

        const target = document.getElementById(id);
        if (!target) return;

        e.preventDefault();
        smoothScrollToTarget(target);

        try {
          history.pushState(null, '', `#${id}`);
        } catch (err) {}
      });
    });
  }

  function setStickyVisible(root, isVisible) {
    if (!root) return;

    const sticky = root.querySelector(SELECTOR_STICKY);
    const preSticky = root.querySelector(SELECTOR_PRE_STICKY);

    const revealEnabled = root.getAttribute('data-oseddrev-reveal-enabled') === '1';
    const isRevealed = root.classList.contains('oseddrev-revealed');

    if (revealEnabled && !isRevealed) {
      root.classList.remove('oseddrev-sticky-active');

      if (sticky) {
        sticky.setAttribute('aria-hidden', 'true');
      }

      if (isVisible) {
        root.classList.add('oseddrev-pre-sticky-active');
        if (preSticky) preSticky.setAttribute('aria-hidden', 'false');
      } else {
        root.classList.remove('oseddrev-pre-sticky-active');
        if (preSticky) preSticky.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    root.classList.remove('oseddrev-pre-sticky-active');
    if (preSticky) {
      preSticky.setAttribute('aria-hidden', 'true');
    }

    if (!sticky) return;

    if (isVisible) {
      root.classList.add('oseddrev-sticky-active');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      root.classList.remove('oseddrev-sticky-active');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  function bindStickyObserver(root, mainCta) {
    if (!root || !mainCta) return;

    if (root.__oseddrevStickyObserved) return;
    root.__oseddrevStickyObserved = true;

    if (!('IntersectionObserver' in window)) {
      const onScroll = () => {
        const r = mainCta.getBoundingClientRect();
        const inView = r.bottom > 0 && r.top < window.innerHeight;
        setStickyVisible(root, !inView);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
      return;
    }

    const obs = new IntersectionObserver(
      (entries) => {
        const entry = entries && entries[0];
        if (!entry) return;

        const inView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        setStickyVisible(root, !inView);
      },
      {
        root: null,
        threshold: [0, 0.25, 0.5, 1],
      }
    );

    obs.observe(mainCta);
    root.__oseddrevStickyObs = obs;
  }

  function setBusy(btn, isBusy) {
    if (!btn) return;
    btn.disabled = !!isBusy;
    btn.setAttribute('aria-busy', isBusy ? 'true' : 'false');

    if (isBusy) btn.classList.add('is-busy');
    else btn.classList.remove('is-busy');
  }

  function explodeConfetti(root) {
    if (!root) return;

    const layer = root.querySelector('[data-oseddrev-confetti-layer]');
    if (!layer) return;

    layer.innerHTML = '';

    const colors = ['#ec0387', '#f7c85b', '#7ee7f3', '#ffffff', '#000000'];
    const piecesCount = 44;

    for (let i = 0; i < piecesCount; i += 1) {
      const piece = document.createElement('span');
      piece.className = 'oseddrev-topshop__confettiPiece';

      const spreadX = Math.round((Math.random() * 2 - 1) * 380);
      const spreadY = Math.round(-150 - Math.random() * 300);
      const rotate = Math.round((Math.random() * 2 - 1) * 720);
      const delay = Math.round(Math.random() * 110);
      const width = 8 + Math.round(Math.random() * 7);
      const height = 12 + Math.round(Math.random() * 12);

      piece.style.setProperty('--oseddrev-confetti-x', `${spreadX}px`);
      piece.style.setProperty('--oseddrev-confetti-y', `${spreadY}px`);
      piece.style.setProperty('--oseddrev-confetti-r', `${rotate}deg`);
      piece.style.background = colors[i % colors.length];
      piece.style.width = `${width}px`;
      piece.style.height = `${height}px`;
      piece.style.animationDelay = `${delay}ms`;

      layer.appendChild(piece);
    }

    window.setTimeout(() => {
      layer.innerHTML = '';
    }, 1400);
  }

  function revealOfferCard(root) {
    if (!root || root.classList.contains('oseddrev-revealed')) return;

    explodeConfetti(root);
    root.classList.add('oseddrev-revealed');

    window.setTimeout(() => {
      const mainCta = root.querySelector(SELECTOR_CTA);
      if (mainCta && root.__oseddrevStickyObserved) {
        const r = mainCta.getBoundingClientRect();
        const inView = r.bottom > 0 && r.top < window.innerHeight;
        setStickyVisible(root, !inView);
      }
    }, 340);
  }

  function bindRevealWall(root) {
    if (!root) return;

    const revealEnabled = root.getAttribute('data-oseddrev-reveal-enabled') === '1';
    if (!revealEnabled) return;

    const revealBtn = root.querySelector(SELECTOR_REVEAL_BTN);
    if (!revealBtn) return;

    revealBtn.addEventListener('click', () => {
      revealOfferCard(root);
    });
  }

  async function handleCheckoutClick(btn) {
    const root = btn.closest(SELECTOR_ROOT);
    if (!root) return;

    if (root.__oseddrevCheckoutSubmitting) return;
    root.__oseddrevCheckoutSubmitting = true;

    const mainCta = root.querySelector(SELECTOR_CTA);
    const stickyCta = root.querySelector(SELECTOR_STICKY_CTA);

    setStatus(root, '');
    setBusy(mainCta, true);
    setBusy(stickyCta, true);

    try {
      const clearCart = btn.getAttribute('data-oseddrev-clear-cart') === '1';
      const mainVariantIdRaw = (btn.getAttribute('data-oseddrev-main-variant') || '').trim();
      const mainQty = Number(btn.getAttribute('data-oseddrev-main-qty') || 1);
      const mainSellingPlanRaw = (btn.getAttribute('data-oseddrev-main-selling-plan') || '').trim();

      const mainVariantId = Number(mainVariantIdRaw || 0);
      const mainSellingPlanId = Number(mainSellingPlanRaw || 0);

      if (!mainVariantId) {
        throw new Error('Missing main variant ID. Please set it in the section settings.');
      }

      let freebies = [];
      const freebiesRaw = btn.getAttribute('data-oseddrev-freebies') || '[]';

      try {
        freebies = JSON.parse(freebiesRaw) || [];
      } catch (e) {
        freebies = [];
      }

      const mainItem = {
        id: mainVariantId,
        quantity: Math.max(1, mainQty || 1),
      };

      if (mainSellingPlanRaw && mainSellingPlanId > 0) {
        mainItem.selling_plan = mainSellingPlanId;
      }

      const freebieItems = (freebies || [])
        .filter((it) => it && Number(it.id) > 0)
        .map((it) => ({
          id: Number(it.id),
          quantity: Math.max(1, Number(it.quantity) || 1),
        }));

      const discountCodes = parseDiscountCodes(btn.getAttribute('data-oseddrev-discounts'));
      const checkoutUrl =
        discountCodes.length > 0
          ? `/checkout?discount=${encodeURIComponent(discountCodes.join(','))}`
          : '/checkout';

      if (clearCart) {
        await postJSON('/cart/clear.js', {});
        await wait(180);
      }

      await addSingleItem(mainItem);

      if (freebieItems.length) {
        try {
          await addItemsBatch(freebieItems);
        } catch (freebieErr) {
          console.warn('OS EDD REV freebies failed to add:', freebieErr);
        }
      }

      window.location.href = checkoutUrl;
      return;
    } catch (err) {
      const msg = err && err.message ? err.message : 'Unable to start checkout. Please try again.';
      setStatus(root, msg);
      setBusy(mainCta, false);
      setBusy(stickyCta, false);
      root.__oseddrevCheckoutSubmitting = false;
    }
  }

  function bindRoot(root) {
    if (!root || root.__oseddrevBound) return;
    root.__oseddrevBound = true;

    const cta = root.querySelector(SELECTOR_CTA);
    if (cta) {
      cta.addEventListener('click', () => handleCheckoutClick(cta));
    }

    const stickyCta = root.querySelector(SELECTOR_STICKY_CTA);
    if (stickyCta) {
      stickyCta.addEventListener('click', () => handleCheckoutClick(stickyCta));
    }

    const preStickyCta = root.querySelector(SELECTOR_PRE_STICKY_CTA);
    if (preStickyCta) {
      preStickyCta.addEventListener('click', () => {
        const offerCard = root.querySelector('.oseddrev-topshop__offerCard');

        revealOfferCard(root);

        window.setTimeout(() => {
          smoothScrollToTarget(offerCard || root);
        }, 20);
      });
    }

    if (cta) {
      bindStickyObserver(root, cta);
    }

    bindRevealWall(root);
    bindInfoDropdowns(root);
    bindRteScrollLinks(root);

    const gallery = root.querySelector('[data-oseddrev-gallery]');
    const mainSlides = root.querySelectorAll('[data-oseddrev-gal-main-slide]');
    const thumbs = root.querySelectorAll('[data-oseddrev-thumb]');
    const thumbViewport = root.querySelector('[data-oseddrev-thumb-viewport]');
    const mainPrev = root.querySelector('[data-oseddrev-main-nav="prev"]');
    const mainNext = root.querySelector('[data-oseddrev-main-nav="next"]');

    if (root.querySelector('.oseddrev-topshop__galThumbs')) {
      root.classList.add('oseddrev-has-thumbs');
    } else {
      root.classList.remove('oseddrev-has-thumbs');
    }

    if (gallery && mainSlides.length && thumbs.length) {
      let index = 0;

      const syncMainNav = () => {
        if (!mainPrev || !mainNext) return;
        const max = Math.max(0, mainSlides.length - 1);
        mainPrev.disabled = index <= 0;
        mainNext.disabled = index >= max;
      };

      const setActive = (nextIndex) => {
        const max = Math.max(0, mainSlides.length - 1);
        index = Math.min(Math.max(nextIndex, 0), max);

        mainSlides.forEach((s, i) => {
          const isActive = i === index;
          s.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (isActive) s.setAttribute('data-oseddrev-active', '1');
          else s.removeAttribute('data-oseddrev-active');
        });

        thumbs.forEach((t, i) => {
          const isActive = i === index;
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) t.setAttribute('data-oseddrev-active', '1');
          else t.removeAttribute('data-oseddrev-active');
        });

        const activeThumb = thumbs[index];
        if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }

        syncMainNav();
      };

      thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          const i = Number(t.getAttribute('data-oseddrev-gal-index') || 0);
          setActive(i);
        });
      });

      if (mainPrev) {
        mainPrev.addEventListener('click', (e) => {
          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          setActive(index - 1);
        });
      }

      if (mainNext) {
        mainNext.addEventListener('click', (e) => {
          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          setActive(index + 1);
        });
      }

      if (thumbViewport) {
        thumbViewport.style.scrollBehavior = 'smooth';
      }
    }
  }

  function init() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(bindRoot);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();